import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from '../../../../node_modules/ng2-toastr';
import { AuthenticationService } from '../../services';
import { DeviceHelper } from '../helpers';

@Injectable()
export class AuthGuard implements CanActivate {
    model: any;
    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastsManager
    ) { }

    canActivate(routeSnap: ActivatedRouteSnapshot) {
        if (!routeSnap.queryParams["token"]) {
            if (localStorage.getItem('isLoggedin')) {
                return true;
            }
            else {
                this.router.navigate(['/login']);
                return false;
            }
        }
    }

    public logInUser(userName?: string, password?: string) {
        if (userName && password) {
            this.model = {
                UserName: userName,
                Password: password
            }
        }
        this.toastr.success('Checking Login Credentials', 'Please wait');
        this.authService.auth(this.model)
            .catch((err: any) => {
                this.toastr.error(err.Message, 'Error');
                return Observable.throw(err);
            }).finally(() => {

            })
            .subscribe((response) => {
                if (response.Success) {
                    localStorage.removeItem('isLoggedin');
                    localStorage.removeItem('currentUser');
                    localStorage.removeItem('secondaryAdminUser');
                    localStorage.clear(); //clear and log out the currently signed-in account

                    let currentUser = response.Data.CurrentUser;
                    let displayName = currentUser.FirstName || currentUser.LastName ? currentUser.FirstName + ' ' + currentUser.LastName : currentUser.UserName
                    let userData = {
                        id: currentUser.Id,
                        isLoggedIn: true,
                        username: currentUser.UserName,
                        role: currentUser.RoleName,
                        displayName: displayName,
                        accountId: currentUser.AccountId,
                        currentUserRaw: currentUser,
                        isActivityAdmin: currentUser.IsActivityAdmin,
                        isAdministrationAdmin: currentUser.IsAdministrationAdmin,
                        Token: response.Data.Token
                    };

                    localStorage.setItem('currentUser', JSON.stringify(userData));
                    localStorage.setItem('isLoggedin', JSON.stringify(true));

                    this.router.navigate([`/users/${currentUser.Id}/edit/new/1`]); // force change account
                }
                else {
                    this.toastr.error('Invalid Password or Password did not matched with the record in the Database.', 'Error');
                    this.router.navigate(['login']);
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/auth.guard.ts